import { z } from 'zod';

import type { MatchesSchema } from '@/shared/api/contract';

/**
 * Pasek person publicznego demo (pakiet demo 2026-08-18, `witryna.md` sek. 7).
 *
 * ⚠ Endpoint jest ZARAZEM sondą „czy to demo": 200 = tenant demo (montujemy pasek),
 * 404 = każdy inny tenant (pasek nie istnieje). Cztery bramki liczy serwer —
 * front niczego nie zgaduje po adresie.
 */

export const demoPersonaSchema = z.object({
  login: z.string(),
  displayName: z.string(),
  /** Rola GŁÓWNA persony (admin > architect > leader > user) — porządek grup paska. */
  role: z.string(),
});

export type DemoPersona = z.infer<typeof demoPersonaSchema>;

export const demoPersonasResponseSchema = z.object({
  /**
   * Jedno wspólne, JAWNE hasło person (werdykt usera 2026-08-18) — pochodzi
   * z konfiguracji wpisu katalogu, nie z bazy; pasek loguje nim zwykłym POST-em.
   */
  password: z.string(),
  personas: z.array(demoPersonaSchema),
});

export type DemoPersonasResponse = z.infer<typeof demoPersonasResponseSchema>;

// Spinacz z kontraktem API (decyzja 74) — jak w pozostałych feature'ach.
export const demoContract = {
  DemoPersona: true satisfies MatchesSchema<DemoPersona, 'DemoPersona'>,
  DemoPersonasResponse: true satisfies MatchesSchema<DemoPersonasResponse, 'DemoPersonasResponse'>,
} as const;
